import React from 'react'
import BundleHugWithCheckboxes from './BundleHugWithCheckboxes'
import FlightsRecentSearchCard from './FlightsRecentSearchCard'
import { PackageSearchParamsType, FlyRecentSearchData } from '../types'
import {
  fireOnBookABundleCheckboxClick,
  fireOnCheckboxChangeEvent,
  fireFlightsOnContinueClickEvent
} from '../GA4Helpers'

export default function FlightRecentSearchWithCheckbox({
  searchData,
  packageSearchParams
}: {
  searchData: FlyRecentSearchData
  packageSearchParams: PackageSearchParamsType
}) {
  return (
    <FlightsRecentSearchCard
      searchData={searchData}
      onContinueSearchClick={fireFlightsOnContinueClickEvent}
    >
      <BundleHugWithCheckboxes
        packageSearchParams={packageSearchParams}
        onBookABundleClick={fireOnBookABundleCheckboxClick}
        onCheckboxChange={(_selectedOption, selectedOptionName) =>
          fireOnCheckboxChangeEvent(selectedOptionName)
        }
      />
    </FlightsRecentSearchCard>
  )
}
